







































































































































import { Component, Vue } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import { RestaurantsApi } from "@/services/api-service";
import RestaurantModule from "@/store/restaurant";
import CFooter from "@/components/CFooter.vue";
import { edDays } from "@/types";
import { SortDirection } from "../api";

@Component({
  components: {
    CHeader,
    CFooter,
  },
})
export default class Top extends Vue {
  private get restaurants() {
    return RestaurantModule.restaurants;
  }

  private get edDays() {
    return edDays;
  }

  private mounted() {
    this.getRestaurants();
  }

  private get getDay() {
    const day = new Date().getDay();
    const days = ["日", "月", "火", "水", "木", "金", "土"];
    return days[day];
  }

  private async getRestaurants() {
    try {
      const restaurantsRes = await RestaurantsApi.instance.getRestaurants(
        16,
        undefined,
        SortDirection.Asc,
        "createdAt"
      );
      RestaurantModule.commitRestaurants(restaurantsRes.data.data.items);
    } catch (err) {
      console.log(err);
    }
  }
}
